var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "coupon-app-container",
      staticStyle: { position: "relative", height: "100%", padding: "15px" },
    },
    [
      _vm.travelFormData
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                "append-to-body": "",
                "modal-append-to-body": "",
                title: _vm.travelFormData.travelName + " - 旅遊團表單維護",
                visible: _vm.dialogTravelFormVisible,
                width: "30%",
              },
              on: {
                opened: _vm.getTravelForms,
                "update:visible": function ($event) {
                  _vm.dialogTravelFormVisible = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "travelFormData",
                  attrs: { model: _vm.travelFormData, "label-width": "120px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "旅遊團名稱" } },
                    [
                      _c("el-tag", [
                        _vm._v(_vm._s(_vm.travelFormData.travelName)),
                      ]),
                    ],
                    1
                  ),
                  _c("el-form-item", { attrs: { label: "表單" } }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-row",
                          [
                            _c("el-col", { attrs: { span: 20 } }, [
                              _c(
                                "div",
                                [
                                  _c("Upload", {
                                    ref: "uploadRefTravel",
                                    attrs: {
                                      accept: ".pdf",
                                      payload: _vm.travelFormData,
                                      "data-obj": _vm.travelFileObj,
                                      limitText:
                                        "檔案須為.pdf格式，限制不超過2000MB",
                                      "limit-file-count": 20,
                                      "use-drag": false,
                                      action:
                                        "TravelSettings/commonFormsForTravel",
                                      "auto-upload": false,
                                      "show-file-list": true,
                                      "form-on-loading-parent": _vm.formLoading,
                                      "btn-txt": "上傳旅遊團專用表單",
                                      "before-file-list":
                                        _vm.travelFormData.commonForms &&
                                        _vm.travelFormData.commonForms.length
                                          ? _vm.travelFormData.commonForms[0]
                                              .files
                                          : [],
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "warning" },
                      on: { click: _vm.saveTravelData },
                    },
                    [_vm._v(" 儲 存 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.dialogTravelFormVisible = false
                        },
                      },
                    },
                    [_vm._v("關 閉")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-tabs",
        {
          staticStyle: { height: "100%" },
          attrs: { type: "border-card" },
          model: {
            value: _vm.tabPosition,
            callback: function ($$v) {
              _vm.tabPosition = $$v
            },
            expression: "tabPosition",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { name: "tab3", label: "分房表" } },
            [_c("agencyTravelersRoomHistory")],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { name: "tab2", label: "回傳表單" } },
            [_c("result-forms")],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { name: "tab1", label: "表單管理" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-card",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.formLoading,
                          expression: "formLoading",
                        },
                      ],
                      staticClass: "box-card",
                      staticStyle: { padding: "10px", height: "100%" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("el-alert", {
                            staticStyle: { color: "#4b4b4b" },
                            attrs: {
                              title:
                                "旅遊團常用表單上傳(最多一次同時上傳20個檔案)，將顯示在領隊APP，表單的功能中。",
                              type: "warning",
                              effect: "dark",
                              closable: false,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 20 } }, [
                                _c(
                                  "div",
                                  [
                                    _c("Upload", {
                                      ref: "uploadRef",
                                      attrs: {
                                        accept: ".pdf",
                                        payload: _vm.formData,
                                        "data-obj": _vm.fileObj,
                                        limitText:
                                          "檔案須為.pdf格式，限制不超過2000MB",
                                        "limit-file-count": 20,
                                        "use-drag": false,
                                        action:
                                          "TravelSettings/saveGroupTourCommonForms",
                                        "auto-upload": false,
                                        "show-file-list": true,
                                        "form-on-loading-parent":
                                          _vm.formLoading,
                                        "btn-txt": "上傳所有旅行團通用表單",
                                        "before-file-list":
                                          _vm.formData.commonForms &&
                                          _vm.formData.commonForms.length
                                            ? _vm.formData.commonForms[0].files
                                            : [],
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { staticStyle: { "margin-top": "10px" } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#4b4b4b" },
                                  attrs: { type: "warning" },
                                  on: { click: _vm.saveData },
                                },
                                [_vm._v(" 儲 存 ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("hr"),
              _c(
                "el-row",
                { staticStyle: { position: "relative", height: "100%" } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { position: "relative", height: "100%" },
                      attrs: { span: 5 },
                    },
                    [
                      _c(
                        "el-form",
                        { staticClass: "filter-form", attrs: { inline: true } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "團號" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "輸入團號" },
                                model: {
                                  value: _vm.listQuery.qry,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listQuery, "qry", $$v)
                                  },
                                  expression: "listQuery.qry",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "團名" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "輸入團名" },
                                model: {
                                  value: _vm.listQuery.qrySecond,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listQuery, "qrySecond", $$v)
                                  },
                                  expression: "listQuery.qrySecond",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("el-button", {
                            staticStyle: {
                              "margin-top": "8px",
                              "margin-left": "5px",
                            },
                            attrs: {
                              type: "primary",
                              icon: "el-icon-search",
                              circle: "",
                              disabled: _vm.listLoading,
                            },
                            on: { click: _vm.getTravels },
                          }),
                          _c("el-button", {
                            staticStyle: { cursor: "pointer" },
                            attrs: {
                              type: "success",
                              loading: _vm.listLoading,
                              circle: "",
                              icon: "el-icon-refresh-left",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.refresh()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    {
                      staticStyle: { position: "relative", height: "100%" },
                      attrs: { span: 18, offset: 1 },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { position: "relative", height: "46%" },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.listLoading,
                                  expression: "listLoading",
                                },
                              ],
                              staticStyle: { width: "100%" },
                              attrs: {
                                size: "mini",
                                data: _vm.list,
                                border: "",
                                fit: "",
                                "highlight-current-row": "",
                                height: "90%",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: "項次",
                                  width: "60",
                                  fixed: "left",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.$index + 1)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: "團號",
                                  width: "160",
                                  fixed: "left",
                                  fixed:
                                    _vm.device !== "mobile" ? "left" : null,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.tourGroupNo)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  align: "left",
                                  label: "團名",
                                  width: "200",
                                  fixed: "left",
                                  fixed:
                                    _vm.device !== "mobile" ? "left" : null,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(row.travelName)),
                                        ]),
                                        _c("div"),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: "出發",
                                  width: "200",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        _c(
                                          "div",
                                          [
                                            _c("el-tag", [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "green",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      row.beginDate +
                                                        " " +
                                                        row.beginTime
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: "回程",
                                  width: "200",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        _c(
                                          "div",
                                          [
                                            _c("el-tag", [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: { color: "red" },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      row.endDate +
                                                        " " +
                                                        row.endTime
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: "指定當團表單",
                                  width: "200",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "primary",
                                              plain: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.editTravelForm(row)
                                              },
                                            },
                                          },
                                          [_vm._v("表單維護")]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("pagination", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.total > 0,
                            expression: "total > 0",
                          },
                        ],
                        attrs: {
                          layout: "prev, pager, next",
                          total: _vm.total,
                          page: _vm.listQuery.page,
                          limit: _vm.listQuery.limit,
                        },
                        on: {
                          "update:page": function ($event) {
                            return _vm.$set(_vm.listQuery, "page", $event)
                          },
                          "update:limit": function ($event) {
                            return _vm.$set(_vm.listQuery, "limit", $event)
                          },
                          pagination: _vm.getTravels,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }